import { createMuiTheme } from '@material-ui/core/styles';
import { flexbox } from '@material-ui/system';
const defaultTheme = createMuiTheme();

export const muiTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#66c4de',
        },
        secondary: {
            light: 'rgba(102,196,222,0.3)',
            main: '#66c4de'
        },
    },
    overrides: {
        MuiIconButton: {
            label: {
                color: '#a9a9a9',
                '&:hover': {
                    color: 'darkgrey!important'
                },
                root: {
                   '&:focus': {
                       outline: 'none !important',
                   }
                }
            },
            colorSecondary: {
                '&:hover': {
                    backgroundColor: 'transparent',
                }
            },
            colorInherit: {
                paddingTop: 20,
            },
            root: {
                '&:hover': {
                    backgroundColor: 'transparent',
                }
            }
        },
        MuiCheckbox: {
            colorSecondary: {
                color: '#66c4de',
                '&$checked': {
                    color: '#66c4de',
                    '&:hover': {
                        backgroundColor: 'rgba(0,0,0,0.02)',
                    }
                },
            }
        },
        MuiToolbar: {
            root: {              
                backgroundColor: 'white',
                actions: {
                    '&focus': {
                        outiline: 'none'
                    }
                }
            },
            gutters: {
                [defaultTheme.breakpoints.down('sm')]: {
                    display: 'flex',
                    flexDirection: 'column'
                }, 
            }
        },
        MuiTablePagination: {
            toolbar: {
                [defaultTheme.breakpoints.down('sm')]: {
                    display: 'flex',
                    flexDirection: 'row'
                }, 
            }
        },
        MuiTable: {
            root: {
                border: "1px solid white !important",
                position: "relative",
            }
        },
        MuiTableRow: {
            head: {
                height: 50,
                // backgroundColor: "blue"
            },
            root: {
                height: 40,
                borderBottom: '1px solid white !important',
            }
        },
        MTableHeader: {
            header: {
                //backgroundColor: "pink"
            }
        },
        MuiTableHead: {
            root: {
                // backgroundColor: "red"
            }
        },
        MuiTableCell: {
            head: {
                padding: 0,
                fontSize: '14px !important',
                backgroundColor: "#white!important",
                fontFamily: "Poppins, Helvetica Neue, Arial, sans-serif",
                paddingLeft: 24
            },
            root: {
                borderBottom: "0 solid transparent",
                padding: 0,
                '&:last-child': {
                    paddingRight: 0,
                }
            },
            alignLeft: {
                fontSize: 15,
                height: 60
            }
        },
        MuiPaper: {
            elevation2: {
                boxShadow: 'none',
                margin: '0 auto',
                position: 'initial !important',
            },
            rounded: {
                top: '100px !important',
                width: '100%',
                //border: '1px solid white',
            }
        },
        MuiTypography: {
            h6: {
                paddingTop: 10,
                textTransform: 'none',
            }
        },
        MuiTextField: {
            root: {
                paddingTop: 5,
                paddingRight: 16,
            }
        },
        MuiStepLabel: {
            label: {
                color: 'rgba(102, 196, 222, 0.7) !important',
            },
            active: {
                color: 'rgba(102, 196, 222, 1) !important',
            },
            completed: {
                color: 'rgba(102, 196, 222, 0.9) !important',
            },
        }
    },
});